// src/components/ChargingStation/PaymentMethod.ios.tsx
import React from "react";

/**
 * On iOS, we use the native Payment Sheet dialog instead of Stripe Elements.
 * This component is never rendered, because on native we handle payment entirely
 * via the hook + CheckoutSection. So we just return null here.
 */
const PaymentMethodIOS: React.FC = () => {
  return null;
};

export default PaymentMethodIOS;
